




















import { defineComponent } from "@vue/composition-api";
import useOnboarding from "@/hooks/useOnboarding";
import { OnboardingNames } from "@/hooks/useOnboarding/const";
import BaseButton from "@/components/BaseButton";
import BaseIconButton from "@/components/BaseIconButton";

export default defineComponent({
  name: "BannerFundraisingGoals",
  components: { BaseIconButton, BaseButton },
  setup(_, { root }) {
    const { show, hide, complete } = useOnboarding(OnboardingNames.FUNDRAISING_GOALS_PROFILE);

    const onClick = () => {
      complete();
      root.$router.push({ name: "goals" });
    };

    return {
      show,
      hide,
      complete,
      onClick,
    };
  },
});
